import {loadUIConfig} from "@digatex/digatex-ui-lib";

import ProjectUIConfig from "./config/ui-config.json";

export const properties = {
	ihLink: process.env.REACT_APP_IH_LINK,
	dmLink: process.env.REACT_APP_DM_LINK,
	khLink: process.env.REACT_APP_KH_LINK,
	reportingLink: process.env.REACT_APP_REPORTING_LINK,
	analyticsLink: process.env.REACT_APP_WB_LINK,
	assetHubLink: process.env.REACT_APP_EH_LINK,
	landingHeaderName: process.env.REACT_APP_LANDING_NAME || "SIMS Platform",

	kbrColors: {
		pantone301Blue: "#004987",
		lightBlue: "#A2C7E2",
		yellow: "#ffda00",
		dark: "#00205C",
		green: "#00783F",
		black: "#231f20",
		vividCeruleanBlue: "#007fc5",
		acajouMarron: "#4c212a",
	},
};

export const OWNER = process.env.REACT_APP_CLIENT_NAME;
export const JIRA_DATA_KEY = process.env.REACT_APP_JIRA_DATA_KEY;
export const APP_INSTANCE = process.env.REACT_APP_INSTANCE || "Local";
export const UI_CONFIG = ProjectUIConfig.dummy ? loadUIConfig() : ProjectUIConfig;
